<template>
    <transition name="shortcutprompt" id="shortcutprompt">
        <div v-show="show" class="quick-shortcuts">
            <span class="quickShortcut-txt">{{ nowContent }}</span>
        </div>
    </transition>
</template>

<script>
import EventBus from '@/js/event_bus';
import PainterProxy from '@/js/painter/proxy';
import { store } from '@/store';
import { TOOLS, ALIVE_TYPE } from '@/js/toolbar/tools';


export default {
    name: "MenuMiddle",
    data: function () {
        return {
            show: false,
            shortcuts: [],
            nowContent: "測試文字長度以及大小",
            index: -1
        }
    },
    methods: {
        setData(data) {
            this.shortcuts = data;
        },
        nextShortcut: function () {
            if (this.shortcuts.length == 0) {
                this.nowContent = '';
                return;
            }

            this.index++;
            // 循環切換捷徑功能
            if (this.index >= this.shortcuts.length) {
                this.index = 0;
            }

            // this.triggerShortcut();
            

            // store.nowTool = this.shortcuts[this.index].tool;
            this.triggerTool(this.shortcuts[this.index].tool)
        },
        triggerTool(tool) {
            if (store.toolMap.get(tool)) {
                switch (store.toolMap.get(tool).KEEP_ALIVE) {
                    case ALIVE_TYPE.KEEP:
                        this.triggerShortcut();
                        store.nowTool = tool;
                        store.setPreviousTool(tool);
                        break;
                    case ALIVE_TYPE.ONCE:
                        EventBus.getInstance().emit(TOOLS.SELECTION.TOOL);
                        this.triggerShortcut();
                        store.nowTool = tool;
                        break;
                    case ALIVE_TYPE.NONE:
                        this.triggerShortcut();
                        store.nowTool = store.prevTool;
                        break;
                }
            } else {
                this.triggerShortcut();
                store.nowTool = store.prevTool;
            }


            if (tool == TOOLS.TOOL_BOX.TOOL) {
                return;
            }

            if (tool == TOOLS.GO_PAGE.TOOL) {
                return;
            }

            if (tool == TOOLS.WHITE_BOARD.TOOL) {
                store.setWhiteboardDisabledTools();
            }

            EventBus.getInstance().emit("close_tool_box");
            EventBus.getInstance().emit("close_quick_directory");
        },
        triggerShortcut() {
            let toolValue = this.shortcuts[this.index].toolValue;
            if (toolValue.type === "drawingPenLight-tool" || toolValue.type === "drawingPen-tool") {
                // 組合句子 捷徑名稱 筆刷種類 筆刷顏色 筆刷填滿 筆刷大小
                this.nowContent = `${this.shortcuts[this.index].toolName} ${toolValue.brushType} ${toolValue.color} ${toolValue.solid} 寬度${toolValue.brushSize}`;

                //使用畫筆或螢光筆工具，並且設定值
                PainterProxy.getInstance().setDrawTool(this.shortcuts[this.index].toolValue.operate, this.shortcuts[this.index].toolValue.brushSetting);
                PainterProxy.getInstance().setWidth(this.shortcuts[this.index].toolValue.operate, Number(this.shortcuts[this.index].toolValue.brushSize));
                PainterProxy.getInstance().setColor(this.shortcuts[this.index].toolValue.operate, this.shortcuts[this.index].toolValue.colorSetting);
                PainterProxy.getInstance().setHollow(this.shortcuts[this.index].toolValue.operate, this.shortcuts[this.index].toolValue.soildSetting);
                EventBus.getInstance().emit(this.shortcuts[this.index].tool);
                PainterProxy.getInstance().changeTool(this.shortcuts[this.index].toolValue.brushSetting);
            }
            else if (this.shortcuts[this.index].tool === "textBox-tool") {
                // 組合句子 捷徑名稱 文字顏色 字級大小
                this.nowContent = `${this.shortcuts[this.index].toolName} ${toolValue.color} ${toolValue.color} 字級${toolValue.fontSize}`;
            }
            else {
                // 其他
                this.nowContent = `${this.shortcuts[this.index].toolName}`;
                EventBus.getInstance().emit(this.shortcuts[this.index].tool);
            }
        }

    }
}
</script>

<style scoped>

</style>